<template>
  <v-card class="mb-4"
          v-if="showPublishing">
    <v-card-title>
      Publishing
    </v-card-title>
    <v-simple-table>
      <tbody>

      </tbody>
    </v-simple-table>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import find from "lodash/find";

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    reviewer() {
      if (this.presentation.reviewer_id) {
        return find(this.users, u => u.id === this.presentation.reviewer_id);
      }
      return null;
    },
    showPublishing() {
      return this.team.publish_enabled;
    }
  }
}
</script>
